import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface TimeRangeNotificationProps {
    onCloseTimeRangeNotification: () => void;
  }

const TimeRangeNotification: React.FC<TimeRangeNotificationProps> = ({onCloseTimeRangeNotification}) => {
    return(
        <div className="simulation-notification">
 <div
  style={{
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    position: "relative", // Needed for absolute positioning of the close button
  }}
>
  <div
    style={{
      flex: 1, // This makes the Notification text take the available space
      textAlign: "center", // Centers the text horizontally
    }}
  >
    Notification!
  </div>
  <div
    style={{
      position: "absolute", // Absolutely position the close button
      right: "20px", // 20px margin from the right
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <FontAwesomeIcon
      onClick={() => {onCloseTimeRangeNotification()}}
      onTouchStart={() => {onCloseTimeRangeNotification()}}
      style={{
        border: "2px solid #dc143c",
        borderRadius: "50%",
        width: "12px",
        height: "12px",
        color: "#dc143c",
        cursor: "pointer",
      }}
      size="xl"
      icon={faClose}
    />
  </div>
</div>

      <div
        style={{
          width: "100%",
          height: "100%",
          padding:"10px 0"
          /* display:"inline-block" */
        }}
      >
        The date range exceeds 6 months
      </div>
      <div
        style={{
          width: "100%",
          borderRadius: "0 0 5px 5px",
          backgroundColor: "#4BB543",
          height: "75%",
          /* display:"inline-block" */
        }}
      ></div>
    </div>
    );
}

export default TimeRangeNotification;